import React from 'react';

import { STEPS } from '../constants';

export default class CurrentState extends React.Component {
    constructor(props) {
        super(props);

        this.moveBack = this.moveBack.bind(this);
    }

    render() {
        return (<ul className="current-state">
            <li className={this.props.currState === STEPS.GENERAL_DETAILS ? "active" : ""}
                onClick={this.moveBack}></li>
            <li className={this.props.currState === STEPS.PERSONAL_DETAILS ? "active" : ""}></li>
            <li className={this.props.currState > STEPS.PERSONAL_DETAILS ? "active" : ""}></li>
        </ul>);
    }

    moveBack() {
        if (this.props.currState === STEPS.PERSONAL_DETAILS) {
            this.props.onPointClick(STEPS.GENERAL_DETAILS);
        }
    }
}


// WEBPACK FOOTER //
// ./Src/Appointment/AppointmentScheduler/CurrentState/CurrentState.jsx